import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, LoadingController, AlertController } from '@ionic/angular/lazy';
import moment from 'moment-timezone';
import { Capacitor } from '@capacitor/core';
import { DateTimePickerPage } from 'src/app/modals/date-time-picker/date-time-picker.page';
import { ObserverService } from 'src/app/services/observer.service';
import { QuoteService } from 'src/app/services/quote.service';

@Component({
    selector: 'app-quote-cancel',
    templateUrl: './quote-cancel.page.html',
    styleUrls: ['./quote-cancel.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class QuoteCancelPage implements OnInit {

    spinner = null;
    loading_spinner = null;
    loading = false;
    online = true;
    moment = moment;
    @Input() quote_id = null;
    quote = null;
    user = null;
    formatted_cancelled_date = null;
    modal_css_class = '';
    date_modal_css_class = '';
    params = {};

    // modal flags
    date_picker_modal_open = false;

    constructor(
        public modalController: ModalController,
        public loadingController: LoadingController,
        public alertController: AlertController,
        private observerService: ObserverService,
        private quoteService: QuoteService,
    ) { }

    ngOnInit() {

        if(Capacitor.isNativePlatform()) {
            this.modal_css_class = 'fullscreen';
            this.date_modal_css_class = 'backdrop';
        }

        if(this.quote_id) {


             this.loadData().then(() => { }).catch(() => { });

            // NOTE: default cancelled date
            this.params['cancelled_date'] = this.moment().format("YYYY-MM-DDTHH:mm");
            this.formatted_cancelled_date = this.moment(this.params['cancelled_date']).format("D MMM YYYY, HH:mm");

        }

        this.observerService.subscribe('network_status_changed|quote_cancel_modal', (network_status) => {
            if(network_status) {
                this.online = network_status.connected;
                if(this.online) {
                    this.loadData().then(() => { }).catch(() => { });
                }
                else {
                    this.presentAlert("Offline", "You must be online to cancel a quote please check your network connection and try again.");
                }
            }
        });

    }

    loadData() {
        return new Promise<void>((resolve, reject) => {
            this.presentLoadingSpinner("Loading quote").then(() => {
                this.loadQuote().then(() => {
                    this.loading_spinner.dismiss();
                    resolve();
                })
                .catch(() => {
                    this.loading_spinner.dismiss();
                    reject();
                });
            });
        });
    }

    ngOnDestroy() {
        this.observerService.destroy("network_status_changed|quote_cancel_modal");
    }

    loadQuote() {
        return new Promise<void>((resolve, reject) => {
            this.quote = null;
            this.quoteService.getQuote(this.quote_id).then((quote) => {
                if(quote) {
                    this.quote = quote;
                }
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
    }

    close() {
        this.modalController.dismiss();
    }

    cancel() {

        let validated = true;

        if(this.params['cancelled_date'] == null || this.params['cancelled_date'].trim() === "") {
            validated = false;
            this.presentAlert("Missing cancelled date", "Please select a cancelled date.");
        }

        if(validated) {

            if(this.params['cancelled_date']) {
                this.params['cancelled_date'] = this.moment(this.params['cancelled_date']).utc().toISOString();
            }

            this.cancelQuote().then(() => {
                this.modalController.dismiss();
            });

        }
    }

    cancelQuote() {
        return new Promise<void>((resolve, reject) => {
            this.presentSpinner("Cancelling quote").then(() => {
                this.quoteService.cancelQuote(this.quote.id, this.params).then(() => {
                    this.spinner.dismiss();
                    resolve();
                })
                .catch(() => {
                    this.spinner.dismiss();
                    reject();
                });
            });
        });
    }

    async presentDateTimePickerModal() {
        if(!this.date_picker_modal_open) {
            this.date_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: DateTimePickerPage,
                cssClass: this.date_modal_css_class,
                componentProps: {
                    date: (this.params['cancelled_date'] ? this.params['cancelled_date'] : ""),
                    format: "date-time",
                    clear_date: false
                }
            })
            modal.onDidDismiss().then((data) => {
                this.date_picker_modal_open = false;
                if(data.data) {
                    this.params['cancelled_date'] = data.data['date'];
                    this.formatted_cancelled_date = this.moment(this.params['cancelled_date']).format("D MMM YYYY, HH:mm");
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            cssClass:'alert',
            buttons: ['OK']
        });
        await alert.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

    async presentLoadingSpinner(message) {
        this.loading = true;
        this.loading_spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        this.loading_spinner.onDidDismiss().then(() => {
            this.loading = false;
        });
        await this.loading_spinner.present();
    }

}